/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadForm
 */
export interface CreateLeadForm {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadForm
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadForm
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadForm
     */
    dawaAddressId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadForm
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadForm
     */
    isMechanicLead?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadForm
     */
    recaptcha?: string;
}

export function CreateLeadFormFromJSON(json: any): CreateLeadForm {
    return CreateLeadFormFromJSONTyped(json, false);
}

export function CreateLeadFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'email': json['email'],
        'dawaAddressId': !exists(json, 'dawaAddressId') ? undefined : json['dawaAddressId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'isMechanicLead': !exists(json, 'isMechanicLead') ? undefined : json['isMechanicLead'],
        'recaptcha': !exists(json, 'recaptcha') ? undefined : json['recaptcha'],
    };
}

export function CreateLeadFormToJSON(value?: CreateLeadForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'email': value.email,
        'dawaAddressId': value.dawaAddressId,
        'message': value.message,
        'isMechanicLead': value.isMechanicLead,
        'recaptcha': value.recaptcha,
    };
}


